import { handleActions } from 'redux-actions';
import {
  cleanupAction,
  getAssetRequest,
  getAssetSuccess,
  getAssetError,
} from './assetInfoAction';

const defaultState = {
  asset: null,
  isGetting: true,
  getError: null
};

export default handleActions(
  {
    [getAssetRequest](state) {
      return {
        ...state,
        isGetting: true,
        getError: null,
      };
    },
    [getAssetSuccess](state, { payload }) {
      return {
        ...state,
        asset: payload,
        isGetting: false,
        getError: null,
      };
    },
    [getAssetError](state, { payload }) {
      return {
        ...state,
        isGetting: false,
        getError: payload,
      };
    },
    [cleanupAction](){
      return{
        ...defaultState
      }
    }
  },
  defaultState,
);